import { apiCall, ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { utcIntialDate, utcFinalDate } from '../../../utils/dateHelper'

// Mapeo de keys frontend (camelCase) a los parámetros del StockMovementKardexFilterDto (PascalCase)
const filterKeyMapping: Record<string, string> = {
  sku: 'Sku',
  ean13: 'Ean13',
  productOriginId: 'ProductOriginId',
  warehouseId: 'WarehouseId',
  typeMovementeId: 'TypeMovementeId',
  positionCode: 'PositionCode',
  typePositionId: 'TypePositionId',
  workOrderId: 'WorkOrderId',
  asnId: 'AsnId',
  pickingRouteId: 'PickingRouteId',
  userId: 'UserId',
  batchNumber: 'BatchNumber'
}

// Agrega los filtros seleccionados al query, mapeando keys y el rango de fechas.
const appendFilters = (queryParams: URLSearchParams, filters: Filter[]) => {
  filters.forEach((filter) => {
    // El daterange emite dos filtros separados: initialDateFilter / finalDateFilter
    if (filter.key === 'initialDateFilter') {
      queryParams.append('InitialDate', utcIntialDate(filter.value))
      return
    }
    if (filter.key === 'finalDateFilter') {
      queryParams.append('FinalDate', utcFinalDate(filter.value))
      return
    }
    // El rango de expiración emite initialExpirationDateFilter / finalExpirationDateFilter
    if (filter.key === 'initialExpirationDateFilter') {
      queryParams.append('InitialExpirationDate', utcIntialDate(filter.value))
      return
    }
    if (filter.key === 'finalExpirationDateFilter') {
      queryParams.append('FinalExpirationDate', utcFinalDate(filter.value))
      return
    }

    const backendKey = filterKeyMapping[filter.key] || filter.key
    queryParams.append(backendKey, filter.value)
  })
}

export const getKardexList = (
  filters: Filter[],
  page: number,
  pageSize: number
) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  appendFilters(queryParams, filters)

  // El endpoint no soporta ordenamiento (sin parámetro sorters)
  return apiCall(
    'GET',
    `${ApiConfig.StockMovementKardexApi}?${queryParams.toString()}`
  )
}

// Exporta el Kardex con los filtros seleccionados. El backend devuelve
// { file (base64), mimeType, name } para descargar.
export const exportKardexToExcel = (filters: Filter[]) => {
  const queryParams = new URLSearchParams()
  queryParams.append('offset', new Date().getTimezoneOffset().toString())

  appendFilters(queryParams, filters)

  return apiCall(
    'GET',
    `${ApiConfig.ProcessApi}/KardexMassive?${queryParams.toString()}`
  )
}
